/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import {Dashboard} from '../Dashboard'

const DashboardLayout: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          
        </div>
      </div>
      
      <Dashboard />
    </>
  )
}

export {DashboardLayout}
